import React from 'react';
import {Warehouse} from "../../_helpers/auth-header";
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import MiniDrawer from '../../components/navigation/DrawerMenu'
import StockMenu from '../../components/navigation/stock/topbar'
import { withStyles } from '@material-ui/styles';
import GridToSend from '../../components/stock/GridTosend'

const drawerWidth = 240;
const styles = (theme) => ({
    toolbar: theme.mixins.toolbar,
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
});

const Home = (props) => {
    const { classes } = props;
    //this.setStatestate.gridType = props.gridType;
    return (
        <React.Fragment>
            <CssBaseline />
            <MiniDrawer title={" - Transfer tussen winkels vanuit " + Warehouse()}>


            <Grid>
                <StockMenu  selectedId={2}>

                <GridToSend gridType={"tosend"}></GridToSend></StockMenu>
            </Grid>
            </MiniDrawer>
        </React.Fragment>
    );
}


export default withStyles(styles)(Home);